// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ChatService {
   $http: any
   $q: any
   $timeout: any
   chatConfig: any
   chatScope: any
   completeCallback: any
   offlineText: any
   onlineText: any
   pollingUrl: any
   scope: any
   successCallback: any
   translationService: any
   widgetConfig: any
   constructor(config: any, $timeout: any, $location: any, translationService: any, $q: any, $http: any, $sce: any) {
      this.setStatus = this.setStatus.bind(this)
      this.checkAvailability = this.checkAvailability.bind(this)
      this.getSpringShareInfo = this.getSpringShareInfo.bind(this)
      this.email = this.email.bind(this)
      this.$timeout = $timeout
      this.translationService = translationService
      this.$q = $q
      this.$http = $http
      this.chatConfig = config.data.chat
      this.widgetConfig = this.chatConfig.widget
      this.offlineText = this.translationService.translations.CHAT_IS_OFFLINE
      this.onlineText = this.translationService.translations.CHAT_WITH_LIBRARIAN
      this.scope = { chat: {
         enabled:
        ['libraryh3lp', 'springshare', 'questionpoint', 'whatsapp'].includes(this.widgetConfig.type) &&
        ['top', 'right'].includes(this.chatConfig.location),
         email: this.chatConfig.email || '',
         type: this.widgetConfig.type || false,
         skin: this.widgetConfig.skin || false,
         locateRight: this.chatConfig.location === 'right',
         imageUrl: this.chatConfig.offlineImage || '',
         linkText: this.offlineText,
         hideText: this.translationService.translations.USE_EMAIL_TO_SEND_QUESTION,
         offlineText: this.offlineText
      }
      }

      this.chatScope = this.scope.chat

      // @ts-expect-error TS(2304) FIXME: Cannot find name 'jabber_resources'.
      if (this.scope.chat.enabled && (typeof jabber_resources !== undefined)) {
         let jabberId
         const port = $location.port() ? `:${$location.port()}` : ""
         // https won't work locally so change this to http when testing locally, but remember to back it out!
         this.chatScope.cssHost = `https://${$location.host()}${port}`

         switch (this.widgetConfig.type) {
            case 'libraryh3lp':
               var queue = this.widgetConfig.queue.toLowerCase()
               if (this.widgetConfig.queue.includes('@')) {
                  jabberId = queue
                  queue = queue.split('@')[0]
               } else {
                  jabberId = `${queue}@chat.libraryh3lp.com`
               }
               var regionMatch = this.widgetConfig.queue.match(/^.*@chat\.(.*)\.libraryh3lp\.com$/)
               var region = regionMatch && regionMatch.length ? `${regionMatch[1]}.` : ""
               var domain = region + 'libraryh3lp.com'
               var chatServer = ['chat.', region, 'libraryh3lp.com'].join('')

               // iframe-related settings
               this.chatScope.iframeSource = `https://${region}libraryh3lp.com/chat/${jabberId}`

               this.pollingUrl = [`${$location.protocol()}:/`, domain, 'presence/jid', queue, chatServer, 'js'].join('/')
               this.pollingUrl = $sce.trustAsResourceUrl(this.pollingUrl)
               // set complete callback for libraryh3lp
               // success callback is never fired because response from request sets global js variables (doesn't return valid json)
               this.completeCallback = () => {
                  // call to libraryh3lp polling sets global js variables
                  // @ts-expect-error TS(2304) FIXME: Cannot find name 'jabber_resources'.
                  if (typeof jabber_resources !== 'undefined') {
                     // @ts-expect-error TS(2304) FIXME: Cannot find name 'jabber_resources'.
                     return this.setStatus(jabber_resources && (jabber_resources.length > 0) && ['available', 'chat'].includes(jabber_resources[0].show))
                  }
               }
               break
            case 'springshare':
               this.chatScope.iid = this.widgetConfig.iid
               this.getSpringShareInfo()
               this.pollingUrl = `${$location.protocol()}://libanswers.com/chat_client_status.php?d=0&iid=${this.widgetConfig.iid}`
               this.successCallback = (data: any) => {
                  return this.setStatus(data && data.status)
               }
               break
            default:
            // Question Point and WhatsApp doesn't have a way to poll their chat widget's
            // availability. Therefore, if it's enabled, set the availability status to always
            // be 'true'
               this.setStatus(true)
         }

         if (!['questionpoint', 'whatsapp', "libraryh3lp"].includes(this.widgetConfig.type)) { 
            this.checkAvailability() 
         } else if (this.widgetConfig.type == "libraryh3lp"){
            this.loadScript()
         }
      }
   }

   setStatus(isAvailable: any) {
      this.chatScope.isAvailable = isAvailable
      if (isAvailable) {
         this.chatScope.imageUrl = this.chatConfig.onlineImage || ''
         return this.chatScope.linkText = this.onlineText
      } else {
         this.chatScope.imageUrl = this.chatConfig.offlineImage || ''
         return this.chatScope.linkText = this.offlineText
      }
   }

   loadScript () {
      const customJS = document.createElement('script')
      customJS.setAttribute('async', 'true')
      customJS.src = this.pollingUrl
      customJS.onload = this.completeCallback
      document.body.appendChild(customJS)
      this.$timeout(this.loadScript, 5 * 60000)
   }

   checkAvailability() {
      // TODO: verify that promise handlers function properly
      this.$http.jsonp(this.pollingUrl).then(this.successCallback || angular.noop, angular.noop).finally(this.completeCallback || angular.noop)

      // poll chat service every 5 minutes - SUM-63274
      return this.$timeout(this.checkAvailability, 5 * 60000)
   }

   // retrieves springshare widget client info (domain, key) from libanswers server rather than using config info
   // TODO: remove config references for domain and key when(if) we remove them from the customizer as they are no longer necessary
   getSpringShareInfo() {
      const processData = (data: any) => {
         if (data) {
            this.chatScope.domain = data.system.domain
            return this.chatScope.key = data.libchat.key
         } else { // retrieve from config
            this.chatScope.domain = this.widgetConfig.domain
            return this.chatScope.key = this.widgetConfig.key
         }
      }

      // TODO: verify that promise handlers function properly
      return this.$http.jsonp(`https://libanswers.com/api_chat_info.php?iid=${this.widgetConfig.iid}`).then(processData
         , () => {
            this.chatScope.domain = this.widgetConfig.domain
            return this.chatScope.key = this.widgetConfig.key
         })
   }

   email(options: any) {
      const recipient = this.chatScope.email
      const deferred = this.$q.defer()
      const {
         promise
      } = deferred
      const data = {
         replyTo: options.replyTo,
         recipients: options.sendCopy ? [recipient, options.replyTo] : recipient,
         subject: this.translationService.translations.QUESTION_FROM_CHAT_DIALOG,
         message: options.message
      }
      this.$http.post("/email/chat", data).then((data: any) => deferred.resolve(data)
         , (data: any) => deferred.reject(data))
      return promise
   }
}

ChatService.$inject = ['configService', '$timeout', '$location', 'translationService', '$q', '$http', '$sce']

angular.module('summonApp.services')
   .service('chatService', ChatService)
